<script>

export default {
    computed: {
        breadItems() {
            const { matched, params } = this.$route
            // eslint-disable-next-line no-unused-vars
            const [, ...items] = matched
            const root = '/app/:appId/workspace/:workspaceId/'
            return items.map(item => {
                let { path } = item
                path = path.split(root)
                return {
                    ...item,
                    path: `/app/${params.appId}/workspace/${params.workspaceId}/${path[1]}`,
                }
            }).filter(item => item.meta.title).map(item => ({
                ...item,
                meta: {
                    ...item.meta,
                    title: typeof item.meta.title === 'function' ? item.meta.title(params) : item.meta.title,
                },
            }))
        },
    },
    methods: {
        //   TODO: 三级导航栏暂未处理
        back() {
            this.$router.go(-1)
        },
    },
    render() {
        const { breadItems } = this
        return (
            breadItems.length > 0
                ? <div class="app-breadcrumb">
                    {
                        breadItems.length > 1 && <span class="icon-back" dragable="false" onClick={this.back} />
                    }
                    <hc-breadcrumb separator="/" >
                        {
                            breadItems.map((item, index) => (
                                <hc-breadcrumb-item replace to={item.path}>
                                    {item.meta.title}
                                    
                                    {
                                        item.meta.tips
                                        && index === breadItems.length - 1
                                        && <hc-tooltip placement="bottom-start" content={item.meta.tips} popper-class="bread-tool-tips">
                                            <pd-icon class="tips" icon="tips"/>
                                        </hc-tooltip>
                                    }
                                </hc-breadcrumb-item>
                            ))
                        }
                    </hc-breadcrumb>
                </div> : null
            
        )
    },
}
</script>

<style lang="less" scoped>
.app-breadcrumb{
    display: flex;
    align-items: center;
    height: 48px;
    line-height: 48px;
    padding: 0 20px;
    background: #fff;
    border-bottom: 1px solid #E9EBEE;
    /deep/ .hc-breadcrumb__item{
        font-size: 12px;
        .hc-breadcrumb__inner{
            line-height: 20px;
            font-weight: 400;
        }
        .pd-icon.tips{
            font-size: 20px;
            color: #666666;
            margin-left: 8px;
            transform: translateY(3px);
        }
    }
    /deep/ .hc-breadcrumb__item:last-child .hc-breadcrumb__inner{
        color: #222 !important;
        font-weight: 700;
    }
    /deep/ .hc-breadcrumb__inner{
        color: #666;
        &:hover{
            color: #507AFE;
        }
    }
    /deep/ .hc-breadcrumb__separator {
        margin: 0 4px;
        color: #666666;
    }
    /deep/ .hc-breadcrumb__item:only-child .hc-breadcrumb__inner{
        font-size: 12px;
    }
    .icon-back{
        width: 14px;
        height: 14px;
        margin-right: 4px;
        cursor: pointer;
        background-image: url('../../assets/img/bread_link.svg');
        background-repeat: no-repeat;
        background-size: contain;
        &:hover{
            background-image: url('../../assets/img/bread_link--active.svg');
        }
    }
}
</style>
<style lang="less">
.bread-tool-tips{
    width: 304px;
    font-size: 12px;
    line-height: 20px;
}
</style>>
